interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  className?: string;
}

export default function Button({
  children,
  isLoading,
  className,
  disabled = false,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={isLoading || disabled}
      className={`
        py-3 px-4 font-fustat-bold text-sm tracking-wider rounded-lg
        transition-colors disabled:opacity-70 disabled:cursor-not-allowed
        bg-primary text-white hover:bg-primary-hover shadow-none
        ${className ?? ''}
      `}
    >
      {isLoading ? <div className="spinner_white" /> : children}
    </button>
  );
}
